import { Routes } from '@angular/router';
import { MainLayoutComponent } from './pages/main-layout/main-layout.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { ThemeBuilderComponent } from './pages/theme-builder/theme-builder.component';
import { DepartmentsListComponent } from './pages/departments-list/departments-list.component';
import { PerformanceViewComponent } from './pages/performance-view/performance-view.component';
import { StudentListComponent } from './pages/personnel/student/student-list/student-list.component';
import { StudentDetailsComponent } from './pages/personnel/student/student-details/student-details.component';
import { GroupListComponent } from './pages/group-list/group-list.component';
import { ClassesListComponent } from './pages/classes-list/classes-list.component';
import { CoursesListComponent } from './pages/courses/courses-list/courses-list.component';
import { CourseDetailsComponent } from './pages/courses/course-details/course-details.component';
import { CourseViewComponent } from './pages/courses/course-view/course-view.component';
import { TeacherCourseDetailsComponent } from './pages/courses/teacher-course-details/teacher-course-details.component';
import { LoginComponent } from './pages/login/login.component';
import { LoginRedirectGuard } from './auth/login-redirect.guard';
import { AuthGuard } from './auth/auth.guard';
import { HodListComponent } from './pages/personnel/hod/hod-list/hod-list.component';
import { HodDetailsComponent } from './pages/personnel/hod/hod-details/hod-details.component';
import { TeacherListComponent } from './pages/personnel/teacher/teacher-list/teacher-list.component';
import { StaffListComponent } from './pages/personnel/staff/staff-list/staff-list.component';
import { PermissionsComponent } from './pages/settings/permissions/permissions.component';
import { MessagesComponent } from './pages/communication/messages/messages-inbox/messages.component';
import { CreateMessageComponent } from './pages/communication/messages/create-message/create-message.component';
import { ConclaveListComponent } from './pages/conclave/conclave-list/conclave-list.component';
import { ConclaveCreateComponent } from './pages/conclave/conclave-create/conclave-create.component';
import { ConclaveDetailComponent } from './pages/conclave/conclave-detail/conclave-detail.component';
import { unauthorizedComponent } from './providers/unauthorized.component';
import { authMenuGuard } from './auth/auth-menu.guard';
import { ProfileComponent } from './pages/profile/profile.component';
import { PersonDetailsComponent } from './components/profile-component/person-details/person-details.component';
import { AddressDetailsComponent } from './components/profile-component/address-details/address-details.component';
import { ParentDetailsComponent } from './components/profile-component/parent-details/parent-details.component';
import { EducationDetailsComponent } from './components/profile-component/education-details/education-details.component';
import { CoCurricularDetailsComponent } from './components/profile-component/co-curricular-details/co-curricular-details.component';
import { WorkExperienceDetailsComponent } from './components/profile-component/work-experience-details/work-experience-details.component';
import { TeacherDetailsComponent } from './pages/personnel/teacher/teacher-details/teacher-details.component';
import { StaffDetailsComponent } from './pages/personnel/staff/staff-details/staff-details.component';
import { ChatsComponent } from './pages/communication/chats/chats.component';
import { SchedulesComponent } from './pages/schedules/schedules.component';



export const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'dashboard', component: DashboardComponent, data: { menu_name: 'Dashboard' }, canActivate: [authMenuGuard] },
      { path: 'departments', component: DepartmentsListComponent, data: { menu_name: 'Department' }, canActivate: [authMenuGuard] },


      { path: 'students', component: StudentListComponent, data: { menu_name: 'Students', action_slug: 'student list' }, canActivate: [authMenuGuard] },
      { path: 'student/:id', component: StudentDetailsComponent, data: { menu_name: 'Students', action_slug: 'view student' }, canActivate: [authMenuGuard] },

      { path: 'hod', component: HodListComponent, data: { menu_name: 'HOD' }, canActivate: [authMenuGuard] },
      { path: 'hod/:id', component: HodDetailsComponent, data: { menu_name: 'HOD' }, canActivate: [authMenuGuard] },

      { path: 'teacher', component: TeacherListComponent, data: { menu_name: 'Teacher' }, canActivate: [authMenuGuard] },
      { path: 'teacher/:id', component: TeacherDetailsComponent, data: { menu_name: 'Teacher' }, canActivate: [authMenuGuard] },

      { path: 'staff', component: StaffListComponent, data: { menu_name: 'Staff' }, canActivate: [authMenuGuard] },
      { path: 'staff/:id', component: StaffDetailsComponent, data: { menu_name: 'Staff' }, canActivate: [authMenuGuard] },

      { path: 'group', component: GroupListComponent, data: { menu_name: 'Group' }, canActivate: [authMenuGuard] },
      { path: 'classes', component: ClassesListComponent, data: { menu_name: 'Classes' }, canActivate: [authMenuGuard] },

      { path: 'courses', component: CoursesListComponent, data: { menu_name: 'Courses' }, canActivate: [authMenuGuard] },
      { path: 'course-detail/:type/:id', component: CourseDetailsComponent, data: { menu_name: 'Courses' }, canActivate: [authMenuGuard] },
      { path: 'view/course/:id', component: CourseViewComponent, data: { menu_name: 'Courses' }, canActivate: [authMenuGuard] },

      { path: 'courses-teacher', component: TeacherCourseDetailsComponent, data: { menu_name: 'Courses' }, canActivate: [authMenuGuard] },

      {
        path: 'performance/:type/:id',
        data: {
          menu_name: 'Students',
          action_slug_by_type: {
            department: 'department performance',
            group: 'group performance',
            class: 'class performance'
          }
        },
        component: PerformanceViewComponent,
        canActivate: [authMenuGuard]
      },

      { path: 'theme-builder', component: ThemeBuilderComponent },

      { path: 'permission', component: PermissionsComponent, data: { menu_name: 'Permission' },canActivate: [authMenuGuard] },

      {
        path: 'chats',
        component: ChatsComponent,
        data: {
          menu_name: 'Chats',
          action_slug_by_type: {
            department: 'department chat student',
            group: 'group chat student',
            class: 'class communication'
          }
        },
        canActivate: [authMenuGuard]
      },

      {
        path: 'messages', children: [
          { path: '', component: MessagesComponent, data: { menu_name: 'Messages' }, canActivate: [authMenuGuard] },
          { path: 'create', data: { menu_name: 'Messages', action_slug_by_type: { group: 'group chat student' } }, component: CreateMessageComponent, canActivate: [authMenuGuard] },

          { path: 'edit/:id', data: { menu_name: 'Messages' }, component: CreateMessageComponent, canActivate: [authMenuGuard] },
        ],
      },

      {
        path: 'conclave', children: [
          { path: '', component: ConclaveListComponent, data: { menu_name: 'Conclave' },canActivate: [authMenuGuard] },
          { path: 'create', data: { menu_name: 'Conclave' }, component: ConclaveCreateComponent, canActivate: [authMenuGuard] },
          { path: 'edit/:id', data: { menu_name: 'Conclave' }, component: ConclaveCreateComponent, canActivate: [authMenuGuard] },
          { path: 'view/:id', data: { menu_name: 'Conclave' }, component: ConclaveDetailComponent, canActivate: [authMenuGuard] },
        ]
      },

      {
        path: 'profile', component: ProfileComponent, data: { menu_name: 'Profile' }, canActivate: [authMenuGuard],
        children: [
          { path: 'person-details', data:{menu_name:'Profile'}, component: PersonDetailsComponent },
          { path: 'address', data:{menu_name:'Profile'}, component: AddressDetailsComponent },
          { path: 'parent-details', data:{menu_name:'Profile'}, component: ParentDetailsComponent },
          { path: 'education', data:{menu_name:'Profile'}, component: EducationDetailsComponent },
          { path: 'co-curricular', data:{menu_name:'Profile'}, component: CoCurricularDetailsComponent },
          { path: 'work-experience', data:{menu_name:'Profile'}, component: WorkExperienceDetailsComponent },
          { path: '', redirectTo: 'person-details', pathMatch: 'full' },
        ]
      },

      {
        path: 'monthly-scheduler',
        component: SchedulesComponent,
        data: { menu_name: 'Monthly Scheduler' }, canActivate: [authMenuGuard]
      },
      {
        path: 'weekly-planner',
        component: SchedulesComponent,
        data: { menu_name: 'Weekly Planner' }, canActivate: [authMenuGuard]
      },

      { path: 'unauthorized', component: unauthorizedComponent }

    ],
  },

  { path: 'login', component: LoginComponent, canActivate: [LoginRedirectGuard] },

  // Catch-all route for unknown paths
  { path: '**', redirectTo: 'dashboard' },
];
